/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { EditableEnvironment } from 'cio/utils/environment/editable';
import EnvironmentModel from 'cio/models/environment';
import { computed } from '@ember/object';
import { ComponentLike } from '@glint/template';
import { IdentifierKey } from 'cio/utils/identifiers';
import SettingsWorkspaceIdentifiersCioId from 'cio/components/settings/workspace-identifiers/cio-id';
import SettingsWorkspaceIdentifiersId from 'cio/components/settings/workspace-identifiers/id';
import SettingsWorkspaceIdentifiersEmail from 'cio/components/settings/workspace-identifiers/email';

interface SettingsWorkspaceIdentifiersArgs {
  readOnly: boolean;
  editableEnvironment: EditableEnvironment;
  environment: EnvironmentModel;
  onToggleChangeIdentifiersById: () => unknown;
  onChangeIdMutability: () => unknown;
  onChooseMigrate: () => unknown;
}

export default class SettingsWorkspaceIdentifiers extends Component<SettingsWorkspaceIdentifiersArgs> {
  readonly identifierComponent: Record<IdentifierKey, ComponentLike<any>> = {
    [IdentifierKey.CioId]: SettingsWorkspaceIdentifiersCioId,
    [IdentifierKey.Id]: SettingsWorkspaceIdentifiersId,
    [IdentifierKey.Email]: SettingsWorkspaceIdentifiersEmail,
  };

  @computed('args.{readOnly,environment.isMigrating}')
  get readOnly() {
    return this.args.readOnly || this.args.environment.isMigrating;
  }
}
